import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_entity_vehicle_engine_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  engine_id: fromDatatype.VarcharDatatypeInterface;
  model_variant_guid: fromDatatype.GuidDataFieldInterface;
  manufacturer_guid: fromDatatype.GuidDataFieldInterface;
  engine_name: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_mst_entity_vehicle_engine_RowClass
  implements bl_fi_mst_entity_vehicle_engine_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  engine_id: fromDatatype.VarcharDatatypeInterface;
  model_variant_guid: fromDatatype.GuidDataFieldInterface;
  manufacturer_guid: fromDatatype.GuidDataFieldInterface;
  engine_name: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
